interface IRestrictedResizeColumnIds {
  myPortfolio: {
    loanTable: string[];
    poolManager: string[];
  };
  marketPlace: {
    marketHomeTable: string[];
    activeTrades: {
      allTradesTable: string[];
      bidsTable: string[];
    };
    executedTradesTable: string[];
  };
}

export const restrictedResizeColumnIds: IRestrictedResizeColumnIds = {
  myPortfolio: {
    loanTable: ['selection'],
    poolManager: ['selection'],
  },
  marketPlace: {
    marketHomeTable: ['view-deal'],
    activeTrades: {
      allTradesTable: ['selection', 'icons'],
      bidsTable: ['selection', 'icons'],
    },
    executedTradesTable: ['selection'],
  },
};
